module.exports = __webpack_public_path__ + "static/media/striped_bar_M2.062ac0da.svg";